export default "__VITE_ASSET__3SS3FnCp__"